module.exports = __webpack_public_path__ + "img/LogoBCP.3d89346d.png";